import ControlledByMixin from './ControlledByMixin.js'

class Deposit extends ControlledByMixin {
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get virtual(){
    return this.bank ? false : true
  }
  get ceased(){
    if(this.cease_date){
      return this.cease_date <= (new Date).to_s()
    } else {
      return false
    }
  }
  get account(){
    return this.constructor.employeeStore.accounts.find(acc => acc.deposit_id === this.id)
  }
  get bank_contact(){
    return this.constructor.employeeStore.peopleById.get(this.bank_contact_id)
  }

  get bank(){
    return this.constructor.employeeStore.banks?.find(bank => bank.id === this.bank_id)
  }

  get is_ss_bank(){
    return this.bank_id === 28 && this.bank_id !== null
  }
}

export default Deposit
